import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { login } from "../../stores";
import loginBackground from "assets/img/bgLogin1.jpg";
import pageImage from "assets/img/full-screen-image-1.jpg";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Col,
  Tab,
  Row,
} from "react-bootstrap";

function LoginPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  const [cardClasses, setCardClasses] = React.useState("card-hidden");
  React.useEffect(() => {
    localStorage.clear();
    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  }, []);
  // const handleClick = () => {
  //   history.push("auth/login-page-client");
  // };

  const handlePrivacyLinkClick = () => {
    window.open("/privacy", "_blank", "noopener,noreferrer");
  };
  return (
    <>
      <div
        className="full-page section-image"
        data-color="black"
        data-image={pageImage}
      >
        <div className="content d-flex align-items-center p-0">
          <Container
            className="d-flex align-items-center justify-content-center"
            style={{ minHeight: "90vh" }}
          >
            <Col>
              <Col className="mx-auto" lg="4" md="7" sm="10">
                <Form
                  action=""
                  className="form"
                  method=""
                  onSubmit={(e) => {
                    e.preventDefault(); // Wajib agar halaman tidak reload
                    login(dispatch, { username, password }, history);
                  }}
                >
                  <Card
                    className="border-0 shadow-2xl"
                    style={{
                      borderRadius: "32px",
                      /* Glassmorphism Effect untuk kesan Luxury & Modern */
                      background: "rgba(0, 26, 51, 0.4)", // Semi-transparent dark sapphire blue
                      backdropFilter: "blur(24px)",
                      WebkitBackdropFilter: "blur(24px)",
                      border: "1px solid rgba(255, 255, 255, 0.15)",
                      borderTop: "1px solid rgba(255, 255, 255, 0.3)",
                      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.7)",
                      overflow: "hidden",
                    }}
                  >
                    <Card.Body className="p-5">
                      {/* Header Section */}
                      <div className="text-left mb-4">
                        <div
                          className="mb-4 d-flex align-items-center justify-content-center animate-float"
                          style={{
                            width: "60px",
                            height: "60px",
                            background: "linear-gradient(135deg, rgba(255, 179, 0, 0.9) 0%, rgba(255, 109, 0, 0.9) 100%)",
                            backdropFilter: "blur(10px)",
                            borderRadius: "18px",
                            boxShadow: "0 10px 20px rgba(255, 179, 0, 0.4), inset 0 1px 0 rgba(255,255,255,0.4)",
                            border: "1px solid rgba(255, 255, 255, 0.2)",
                          }}
                        >
                          <i
                            className="fas fa-lock text-white"
                            style={{ fontSize: "22px" }}
                          ></i>
                        </div>
                        <h2
                          className="m-0 fw-900"
                          style={{
                            color: "#ffffff",
                            fontSize: "32px",
                            letterSpacing: "-1.5px",
                            fontWeight: "900",
                          }}
                        >
                          SIGN IN
                        </h2>
                        <p
                          className="fw-500 mt-1"
                          style={{
                            fontSize: "14px",
                            color: "#cbd5e1",
                            fontWeight: "500",
                          }}
                        >
                          Silakan masuk untuk akses portal monitoring BAP SMS
                          Kalbar .
                        </p>
                      </div>

                      {/* Form Section */}
                      <Form.Group className="mb-4">
                        <label
                          className="small text-uppercase mb-2 d-block"
                          style={{
                            letterSpacing: "1.5px",
                            fontSize: "11px",
                            fontWeight: "800",
                            color: "#FFB300", // PERUBAHAN: Label menggunakan warna Kuning Emas Bank Kalbar
                          }}
                        >
                          NOPEG
                        </label>
                        <Form.Control
                          required
                          className="border-0 input-custom"
                          style={{
                            height: "55px",
                            backgroundColor: "rgba(255, 255, 255, 0.06)",
                            borderRadius: "16px",
                            paddingLeft: "20px",
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#FFFFFF",
                            border: "1px solid rgba(255, 255, 255, 0.08)",
                          }}
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder="Masukkan Nopeg Anda"
                          type="text"
                        />
                      </Form.Group>

                      <Form.Group className="mb-5 position-relative">
                        <label
                          className="small fw-800 text-uppercase mb-2 d-block"
                          style={{
                            letterSpacing: "1.5px",
                            fontSize: "11px",
                            fontWeight: "800",
                            color: "#FFB300",
                          }}
                        >
                          PASSWORD
                        </label>
                        <div className="position-relative password-container">
                          <Form.Control
                            required
                            className="border-0 input-custom"
                            style={{
                              height: "55px",
                              backgroundColor: "rgba(255, 255, 255, 0.06)",
                              borderRadius: "16px",
                              paddingLeft: "20px",
                              paddingRight: "50px", // Ruang untuk icon eye
                              fontSize: "15px",
                              fontWeight: "600",
                              color: "#FFFFFF",
                              border: "1px solid rgba(255, 255, 255, 0.08)",
                            }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            type={showPassword ? "text" : "password"}
                          />
                          <div
                            onClick={() => setShowPassword(!showPassword)}
                            className="eye-icon-container"
                            style={{
                              position: "absolute",
                              right: "15px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              cursor: "pointer",
                              color: "rgba(255, 255, 255, 0.6)",
                              zIndex: 10,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "30px",
                              height: "30px",
                              transition: "color 0.3s ease",
                            }}
                          >
                            <i className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                          </div>
                        </div>
                      </Form.Group>

                      {/* Action Button */}
                      <Button
                        type="submit"
                        onClick={() =>
                          login(dispatch, { username, password }, history)
                        }
                        className="btn-block py-3 fw-800 mb-4 animate-press btn-luxury"
                        style={{
                          borderRadius: "16px",
                          background: "linear-gradient(135deg, rgba(0, 75, 147, 0.8) 0%, rgba(0, 51, 102, 0.9) 100%)",
                          backdropFilter: "blur(10px)",
                          color: "#ffffff",
                          fontSize: "15px",
                          letterSpacing: "1.5px",
                          fontWeight: "800",
                          boxShadow: "0 15px 30px rgba(0, 0, 0, 0.3)",
                          border: "1px solid rgba(255, 255, 255, 0.2)",
                          borderTop: "1px solid rgba(255, 255, 255, 0.4)",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                      >
                        SIGN IN
                      </Button>

                      {/* Footer */}
                      <div className="text-center pt-2">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{ gap: "20px" }}
                        >
                          <a href="/auth/privacy" className="footer-link-bpd">
                            Privacy Policy
                          </a>
                          <div
                            style={{
                              width: "4px",
                              height: "4px",
                              backgroundColor: "rgba(255, 179, 0, 0.4)", // Dot pemisah warna emas soft
                              borderRadius: "50%",
                            }}
                          ></div>
                          <a
                            href="/auth/termsandconditions"
                            className="footer-link-bpd"
                          >
                            Terms & Conditions
                          </a>
                        </div>
                      </div>

                      <style>{`
  /* 1. Kondisi Normal */
  .input-custom {
    color: #FFFFFF !important;
    caret-color: #FFFFFF !important;
    background-color: rgba(255, 255, 255, 0.06) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
  }

  /* 2. Kondisi Focus - Teks jadi gelap, border menyala warna Emas Bank Kalbar */
  .input-custom:focus {
    background-color: #FFFFFF !important; 
    color: #0f172a !important;            
    caret-color: #0f172a !important;        
    border: 1px solid #FFB300 !important;
    box-shadow: 0 0 0 4px rgba(255, 179, 0, 0.25) !important;
    outline: none;
  }

  /* Menangani Autofill */
  .input-custom:-webkit-autofill,
  .input-custom:-webkit-autofill:hover {
    -webkit-text-fill-color: #FFFFFF !important;
    -webkit-box-shadow: 0 0 0px 1000px #001a33 inset !important;
  }

  .input-custom:-webkit-autofill:focus {
    -webkit-text-fill-color: #0f172a !important;
    -webkit-box-shadow: 0 0 0px 1000px #FFFFFF inset !important;
  }

  .input-custom::placeholder {
    color: #64748b !important;
    transition: all 0.3s;
  }

  .input-custom:focus::placeholder {
    opacity: 0;
  }
  
  .animate-float {
    animation: floating 3s ease-in-out infinite;
  }

  @keyframes floating {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-6px); }
  }

  .animate-press {
    transition: transform 0.1s ease, opacity 0.2s ease;
  }

  .animate-press:active {
    transform: scale(0.98);
  }

  .animate-press:hover {
    filter: brightness(1.15);
  }

  .btn-luxury:hover {
    background: linear-gradient(135deg, rgba(0, 85, 165, 0.9) 0%, rgba(0, 61, 122, 1) 100%) !important;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4) !important;
    border-top: 1px solid rgba(255, 179, 0, 0.6) !important;
  }

  .password-container:focus-within .eye-icon-container {
    color: #0f172a !important;
  }
  
  .eye-icon-container:hover {
    color: #FFB300 !important;
  }

  .footer-link-bpd {
    color: #cbd5e1;
    font-size: 12px;
    font-weight: 700;
    text-decoration: none;
    transition: color 0.2s ease;
  }

  .footer-link-bpd:hover {
    color: #FFB300 !important;
  }
`}</style>
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Col>
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url("${loginBackground}")`,
            filter: "brightness(0.55) contrast(1.1)", // Menjaga nuansa korporat bank tetap elegan
          }}
        ></div>
      </div>
    </>
  );
}

export default LoginPage;
